<template>
  <el-row
type="flex"
justify="space-between"
align="middle">
    <div>
      <h1 class="card-container__title">{{ title }}</h1>
      <p class="card-container__subtitle">Tổng số: {{ total }}</p>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="!isEdit"
        type="primary"
        size="small"
        icon="el-icon-plus"
        :disabled="disabled || isEdit"
        :plain="plain"
        @click="$emit('create')"
        >Thêm mới</el-button
      >
      <el-button
        v-if="!isEdit"
        type="primary"
        size="small"
        icon="el-icon-edit"
        @click="() => $emit('edit', true)"
      >
        Chỉnh sửa
      </el-button>
      <el-button
        v-if="isEdit"
        type="info"
        size="small"
        icon="el-icon-close"
        @click="() => handleCancel()"
      >
        Hủy
      </el-button>
      <el-button
        v-if="isEdit"
        type="primary"
        size="small"
        icon="el-icon-check"
        @click="() => handleSave()"
      >
        Lưu
      </el-button>
    </el-row>
  </el-row>
</template>

<script>
import { notification } from "@/utils/common";

export default {
  name: "CardHeader",
  props: {
    title: String,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    isEdit: Boolean,
    newFields: Array,
  },
  methods: {
    handleCancel() {
      this.$emit('edit', false)
    },
    handleSave() {
      this.$emit("save", {
        payload: { fields: JSON.parse(JSON.stringify(this.newFields)) },
        success: () => {
          notification(
            this,
            "success",
            this.isCreate ? "create" : "update",
            `danh sách trường dữ liệu`
          );
          this.$emit('edit', false)
        },
        error: () => {
          notification(
            this,
            "error",
            this.isCreate ? "create" : "update",
            `danh sách trường dữ liệu`
          );
        },
      });
    },
  }
};
</script>

<style lang="scss" scoped></style>
